import { Mui } from "@osu/react-ui";
import { useState } from 'react';
import { useChangeWorkflowMutation, useGetChangeWorkflowOptionsQuery } from '../../services/graphql/api';
import { skipToken } from "@reduxjs/toolkit/query";
import DialogSummaryBox from "../../Common/components/DialogSummaryBox";

const ChangeWorkflowDialog = ({ openDialog, setOpenDialog, searchParams, clearSearchCriteria, clearGrid, skip, totalCount }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [changeWorkflow] = useChangeWorkflowMutation();
    const { data: options } = useGetChangeWorkflowOptionsQuery(skip ? skipToken : undefined);
    
    const [selectedWorkflowType, setSelectedWorkflowType] = useState(options?.[0]?.key || "");
    
    if (skip) { return; }
    const dialogMessage = `Choose a workflow change for the selected population.`

    async function confirmAction(e) {
        e.preventDefault();
        e.stopPropagation();

        if (isSubmitting) return;

        setIsSubmitting(true);

        try {
            // Transform searchCriteria to match SearchAllDataInput format
            // const formattedCriteria = Object.values(searchCriteria)
            //     .filter(criteria => {
            //         const hasAttribute = criteria.selectedAttribute && criteria.selectedAttribute !== '';
            //         const hasOperator = criteria.operator && criteria.operator !== '';
            //         const hasValue = criteria.selectedValue && criteria.selectedValue.toString().trim() !== '';
            //         return hasAttribute && hasOperator && hasValue;
            //     })
            //     .map(criteria => ({
            //         attribute: criteria.selectedAttribute.key,
            //         operator: criteria.operator.KEY,
            //         value: JSON.stringify(criteria.selectedValue)
            //     }));



            const input = {
                criteria: searchParams,
                selectedWorkflowType: selectedWorkflowType
            };

            const result = await changeWorkflow({ input });

            console.log("Change workflow result:", result);

            if (result.data?.status === "success") {
                console.log("Workflow change initiated successfully:", result.data.changeWorkflow);



                // Show success message
                setShowSuccess(true);
            } else {
                console.error("Workflow change failed:", result);
                // TODO: Show error message to user
            }
        } catch (error) {
            console.error("Error changing workflow:", error);
            // TODO: Show error message to user
        } finally {
            setIsSubmitting(false);
        }
    }

    const handleClose = (cancel) => {
        console.log("Dialog closed:", cancel);
        // Clear search criteria and grid
        if (cancel === false) {
            if (clearSearchCriteria) clearSearchCriteria();
            if (clearGrid) clearGrid();
        }
        setOpenDialog(false);
        setShowSuccess(false);
        setSelectedWorkflowType(options[0]?.key || "");
    };


    return (
        <Mui.Dialog
            open={openDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth="sm">
            <Mui.DialogTitle id="alert-dialog-title">Change Workflow</Mui.DialogTitle>

            {showSuccess && (
                <Mui.Alert severity="info" sx={{ margin: 2, marginBottom: 0 }}>
                    Workflow change initiated successfully!
                </Mui.Alert>
            )}

            <Mui.DialogContent>
                {!showSuccess && <Mui.DialogContentText id="alert-dialog-description">{dialogMessage}</Mui.DialogContentText>}

                {!showSuccess && (
                    <Mui.FormControl variant="outlined" fullWidth className={'margin-top-2'}>
                        <Mui.InputLabel id="workflowChange-select-label">Workflow Type</Mui.InputLabel>
                        <Mui.Select
                            labelId="workflowChange-select-label"
                            id="workflowChange-select"
                            value={selectedWorkflowType}
                            onChange={(e) => setSelectedWorkflowType(e.target.value)}
                            label="Change Workflow"
                            sx={{ width: "50%"}}
                        >
                            {options?.map((option) => (
                                <Mui.MenuItem key={option.key} value={option.key}>
                                    {option.value}
                                </Mui.MenuItem>
                            ))}
                        </Mui.Select>
                        <DialogSummaryBox totalCount={totalCount}/>
                    </Mui.FormControl>
                )}

            </Mui.DialogContent>

            <Mui.DialogActions className="padding-2">
                {showSuccess ? (
                    <Mui.Button color="primary" style={{ border: "none" }} variant="contained" onClick={handleClose}>
                        Close
                    </Mui.Button>
                ) : (
                    <>
                        <Mui.Button color="secondary" style={{ border: "none" }} variant="outlined" onClick={() => handleClose(true)}>Cancel</Mui.Button>
                        <Mui.Button disabled={isSubmitting} color="primary" style={{ border: "none" }} variant="contained" onClick={confirmAction}>
                            {isSubmitting && <Mui.CircularProgress size={20} style={{ marginRight: '.5rem' }} />}
                            Change
                        </Mui.Button>
                    </>
                )}
            </Mui.DialogActions>
        </Mui.Dialog>
    );
}

export default ChangeWorkflowDialog;